import { instance } from "libs/api";

import { ApiRoutesMarketing } from "../../constants";
import {
  StopMarketingFlowContactPayload,
  StopMarketingFlowContactResponse
} from "../../marketing.types";

export const requestStopMarketingFlowContact = async ({
  flowId,
  contactId
}: StopMarketingFlowContactPayload): Promise<StopMarketingFlowContactResponse> => {
  return await instance.post(`${ApiRoutesMarketing.Flows}/${flowId}/stop`, {
    contactId
  });
};
